/**
 * 메인 레이아웃의 설정 정보
 * 여러 컴포넌트에서 이 값을 사용함
 */
export const mainLayoutConstants = {
    /**
     * 상단 Appbar 높이
     * 이건 하드코딩해도 되나 모르겠다 testtest
     */
    appbarHeight: 55,

    /**
     * 왼쪽 메뉴 너비
     */
    sidemenuWidth: 350,

    /**
     * 왼쪽 메뉴 배경색
     */
    sidemenuBgColor: '#252526',

    sidemenuBgColorActive: 'rgba(0, 127, 255,0.2)',

    sidemenuFgColor: 'rgba(255, 255, 255, 0.7)',

    sidemenuFgColorActive: '#93edbb',

    sidemenuBorderColorActive: 'rgba(255, 255, 255, 1)',

    /**
     * 왼쪽 구분선 색
     */
    sidemenuDividerColor: '#555555',

    /**
     * 레이아웃 컨텐트 배경색
     */
    contentBgColor: '#fafafa',

    /**
     * 레이아웃 컨텐트 아래쪽 패딩
     */
    contentPaddingBottom: 80,
}
